(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  
  function moveBlogTitle() {
  const contentBlog = document.querySelector(".content-blog");
  const oldTitle = contentBlog.querySelector(".head-article");
  const wrapper = contentBlog.parentElement;
  wrapper.insertBefore(oldTitle, wrapper.firstChild);
}

window.onload = moveBlogTitle;

  
//   function moveBlogTitle() {
//   const contentBlog = document.querySelector(".content-blog");
//   const oldTitle = contentBlog.querySelector(".cms-group-title h1");
//   const wrapper = contentBlog.parentElement;
//   const newTitle = document.createElement("div");
//   newTitle.classList.add("content-blog");
//   newTitle.insertBefore(oldTitle, newTitle.firstChild);
//   wrapper.insertBefore(newTitle, wrapper.firstChild);
// }

// window.onload = moveBlogTitle;

  
//   function createIdFromLabel(str) {
//   str = str.toLowerCase();
//   str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
//   str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
//   str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
//   str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
//   str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
//   str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
//   str = str.replace(/đ/g, "d");
//   // Some system encode vietnamese combining accent as individual utf-8 characters
//   str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng
//   str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
//   return str.trim().split(" ").join("-");
// }

// function renderMenuList() {
//   const wrapper = document.querySelector(".post-item");
//   const menuList = wrapper.querySelectorAll("h3, h4");

//   const newListWithLevel = [];
//   menuList.forEach((item) => {
//     if (item.tagName === "H3") {
//       newListWithLevel.push({ mainLabel: item, subMenu: [] });
//     }
//     if (item.tagName === "H4") {
//       const currentMenu = newListWithLevel[newListWithLevel.length - 1];
//       newListWithLevel[newListWithLevel.length - 1].subMenu = [
//         ...currentMenu.subMenu,
//         item,
//       ];
//     }
//   });

//   console.log('list',newListWithLevel)

//   let menuHtml = `
//       <h4 class="wrapper-name">Các nội dung chính</h4>
//       <ul class="menu-list">
//       ${newListWithLevel.reduce((result, item) => {
//         const id = createIdFromLabel(item.mainLabel.innerText);
//         item.mainLabel.setAttribute("id", id);
//         item.mainLabel.style.paddingTop = '48px';
//         return (
//           result +
//           `
//               <li>
//                   <a href="#${id}" class="menu-label">
//                       <span>${item.mainLabel.innerText}</span>
//                   </a>
//                   ${
//                     item.subMenu.length > 0
//                       ? `<ul class="menu-list">
//                           ${item.subMenu.reduce((subResult, subItem) => {
//                             const subId = createIdFromLabel(subItem.innerText);
//                             subItem.setAttribute("id", subId);
//                             subItem.style.paddingTop = '48px';
//                             return (
//                               subResult +
//                               `
//                                     <li>
//                                         <a href="#${subId}" class="menu-label">
//                                             <span>${subItem.innerText}</span>
//                                         </a>
//                                     </li>
//                                 `
//                             );
//                           }, "")}
//                         </ul>`
//                       : ""
//                   }
//               </li>
//           `
//         );
//       }, "")}
//       </ul>
//     `;

//   const menuWrapper = document.createElement("div");
//   menuWrapper.classList.add("blog-menu-wrapper");
//   menuWrapper.innerHTML = menuHtml;
// wrapper.insertBefore(menuWrapper, wrapper.firstChild);
// }

// window.onload = renderMenuList;



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
